/*
 * Центр уведомлений 1-Э1.9.
 *
 * СТРОКА ЛЕНТЫ РАЗЛИЧАЕТСЯ ТРЕМЯ ПРИЗНАКАМИ, а не цветом: формой точки (квадрат у дела,
 * круг у факта), толщиной рамки и подписью вида. Цвет здесь — четвёртый признак, а не
 * первый: в салоне смотрят на экран телефона при дневном свете, и у каждого десятого
 * мужчины-администратора красный от серого отличается хуже, чем у дизайнера.
 *
 * НА ТЕЛЕФОНЕ КНОПКИ УЕЗЖАЮТ ПОД ТЕКСТ. При ширине 360 три кнопки рядом с текстом
 * оставляют тексту четверть строки, и событие приходится угадывать по первым словам.
 */

.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-3);
  min-height: 0;
}

.head {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex-wrap: wrap;
}

.title {
  margin: 0;
  font-size: var(--font-size-lg);
  font-weight: 600;
}

.headActions {
  margin-left: auto;
  display: flex;
  gap: var(--space-2);
}

.filters {
  flex-wrap: wrap;
}

.error {
  margin: 0;
  font-size: var(--font-size-sm);
  color: var(--danger);
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.groupTitle {
  margin: var(--space-2) 0 0;
  font-size: var(--font-size-xs);
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-secondary);
}

.row {
  display: flex;
  align-items: flex-start;
  gap: var(--space-2);
  padding: 10px 14px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
}

/* Дело — рамка заметнее: строку видно, не читая её. */
.rowWork {
  border-color: var(--border-strong);
}

/* Потерявшее смысл: бледнее и с зачёркнутым текстом, но НЕ убрано. */
.rowStale .text {
  text-decoration: line-through;
}

.rowStale,
.rowRead {
  opacity: 0.82;
}

.dot {
  flex: none;
  width: 10px;
  height: 10px;
  margin-top: 5px;
}

.dotWork {
  border-radius: 2px;
  background: var(--danger);
}

.dotInfo {
  border-radius: 50%;
  background: var(--text-secondary);
}

.body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.meta {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  font-size: var(--font-size-xs);
  color: var(--text-secondary);
}

.type {
  font-weight: 600;
}

.typeWork {
  color: var(--danger);
}

.time {
  white-space: nowrap;
}

.stale {
  color: var(--status-pending-fg);
  font-weight: 600;
}

.text {
  margin: 0;
  font-size: var(--font-size-sm);
  line-height: 1.4;
}

.rowActions {
  flex: none;
  display: flex;
  align-items: center;
  gap: 6px;
}

.more {
  align-self: center;
  margin-top: var(--space-2);
}

.footer {
  margin: 0;
  padding: var(--space-2) 0;
  font-size: var(--font-size-xs);
  line-height: 1.5;
  color: var(--text-secondary);
  text-align: center;
}

.offline {
  margin: 0;
  padding: 10px 14px;
  font-size: var(--font-size-sm);
  color: var(--status-pending-fg);
  background: var(--status-pending-bg);
  border-radius: 10px;
}

@media (max-width: 620px) {
  /* «Прочитать все информационные» на телефоне — отдельной строкой во всю ширину:
     прижатая вправо и перенесённая, она выглядела съехавшей. */
  .headActions {
    width: 100%;
    margin-left: 0;
  }

  .headActions > * {
    flex: 1;
  }

  .row {
    flex-wrap: wrap;
  }

  .rowActions {
    width: 100%;
    /* Главная кнопка справа: палец держит телефон снизу, и справа он достаёт легче. */
    justify-content: flex-end;
    flex-wrap: wrap;
  }
}
